import React from 'react';

import Link from '@material-ui/core/Link';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import {config} from '../../shared/config';
import * as PropTypes from 'prop-types';

const styles = {
    icons: {
        fontSize: 22,
        marginLeft: 4
    },
    links: {
        display: 'inline-flex',
        alignItems: 'center'
    }
};

export class ThirdPartyLink extends React.Component {
    render() {
        return (
            <Link
                href={`${config.core}/alfa/c/maintain-thirdparty(${this.props.thirdPartyNumber},1)`}
                rel="noopener"
                style={styles.links}
                target="_blank"
            >
                {this.props.thirdPartyNumber}
                <OpenInNewIcon style={styles.icons}/>
            </Link>
        )
    }
}

ThirdPartyLink.propTypes = {
    thirdPartyNumber: PropTypes.number
}
